import { createUseStyles } from "react-jss";
import { ITheme } from "../../../constants/theme";
import { isTV } from "../../../utils/platform";
import {
  RATIO_BOX_HEIGHT_VAR,
  RATIO_BOX_WIDTH_VAR,
} from "../../../hooks/useAspectRatioFallback";

export const useStyles = createUseStyles((theme: ITheme) => ({
  rootLarge: {
    insetInlineStart: 0,
    insetInlineEnd: 0,
    insetBlockStart: 0,
    insetBlockEnd: 0,
    margin: 0,
    background: "transparent",
    borderRadius: 0,
    border: "none",
    outline: "none",
    padding: 0,
    overflow: "hidden",
    boxSizing: "border-box",
    width: "100vw",
    height: "100vh",
    maxWidth: "100vw",
    maxHeight: "100vh",
    display: "none",
    flexDirection: "column",
    "&::backdrop": {
      backgroundColor: "rgba(0, 0, 0, 0.90)",
    },
    "&[open]": {
      display: "flex",
    },
  },
  largeContent: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    height: "100%",
    boxSizing: "border-box",
    paddingBottom: isTV && 64,
  },
  videoWrap: {
    flex: 1,
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "center",
    width: "100%",
    minHeight: 0,
    overflow: "hidden",
    position: "relative",
    "&::after": {
      content: '""',
      position: "absolute",
      bottom: 0,
      left: 0,
      right: 0,
      height: 120,
      background:
        "linear-gradient(to bottom, rgba(0,0,0,0) 0%, rgba(0,0,0,0.9) 100%)",
      pointerEvents: "none",
    },
  },
  videoLarge: {
    width: "auto",
    height: "100%",
    maxWidth: "100%",
    aspectRatio: "16 / 9",
    border: "none",
    // webOS 22 (Chromium <=87): no aspect-ratio (16 / 9).
    // `useAspectRatioFallback` on `videoWrap` publishes these vars.
    "@supports not (aspect-ratio: 1 / 1)": {
      width: `var(${RATIO_BOX_WIDTH_VAR})`,
      height: `var(${RATIO_BOX_HEIGHT_VAR})`,
    },
  },
  bottomBar: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    gap: theme.spacing.space24,
    padding: `${theme.spacing.space20}px 90px`,
    background: "rgba(0, 0, 0, 0.9)",
    width: "100%",
    boxSizing: "border-box",
    flexShrink: 0,
  },
  leftCol: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: theme.spacing.space16,
    flex: 1,
    minWidth: 0,
  },
  textCol: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.space4,
    flex: 1,
    minWidth: 0,
    textAlign: "left",
  },
  titleLarge: {
    textAlign: "left",
    margin: 0,
  },
  actionsLarge: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.space8,
    alignItems: "stretch",
    flexShrink: 0,
    "& > *": {
      width: 360,
    },
  },
  qrCode: {
    display: "block",
    width: "96px !important",
    height: "96px !important",
    borderRadius: theme.radius.small,
  },
}));
